import {RequestAxios} from "../../index";
import {PersonnelPhoto} from "./interfaces";
import {API_START} from "../../constants";

export const getHrefMainPhoto = async (Guid: string) => {
    const hrefMainPhotoUrl = `${API_START}/personnel/${Guid}/photos/main`;
    return await RequestAxios.get<PersonnelPhoto>(hrefMainPhotoUrl)
}

//https://app.bitafit.com/core/api/personnel/ guid /photos/main